module.exports = __webpack_public_path__ + "fonts/Perpetua-titling-mt-bold.woff2";